import { useMediaQuery } from 'beautiful-react-hooks';
import STTypo from 'core/shared/typo';
import { TypeOptions } from 'core/shared/typo/typo.models';
import { MEDIA_QUERIES } from 'config/style/breakpoints';
import { REGIONAL_RISK_LEGEND_RISK_CONTAINER } from '@features/regional-overview/domain/tests-id.constants';
import type { RegionalOverviewLevel } from '@features/regional-overview/regional-overview.models';
import { getRiskLevelTranslationKey } from '@features/regional-overview/utils';
import { useTranslation } from 'react-i18next';
import styles from './regional-risk-legend-risk.module.css';

interface RegionalOverviewMapLegendProps {
  riskLevels: RegionalOverviewLevel[];
  title: string;
  showAtBottom?: boolean;
}

const RegionalOverviewMapLegend = ({ riskLevels, title, showAtBottom }: RegionalOverviewMapLegendProps) => {
  const [t] = useTranslation();
  const isMobile = useMediaQuery(MEDIA_QUERIES.MOBILE);
  const typoType = isMobile ? TypeOptions.C2 : TypeOptions.P2;

  if (!riskLevels) return null;

  return (
    <div
      data-testid={REGIONAL_RISK_LEGEND_RISK_CONTAINER}
      className={styles.container}
      data-show-at-bottom={showAtBottom ? 'true' : 'false'}>
      <STTypo data-testid='regional-risk-legend-risk-title' type={typoType} fontWeight={500}>
        {title}
      </STTypo>
      <div className={styles.wrapper} data-testid='regional-risk-risk-legend-wrapper-levels'>
        {riskLevels.map(riskLevel => (
          <div
            className={styles.item}
            data-testid={`regional-risk-risk-legend-${riskLevel.type}`}
            key={`${riskLevel.type}:${riskLevel.value}`}
            style={{ width: `${riskLevel.level}%` }}>
            <div className={styles.riskLegend} data-testid='risk-legend-component' style={{ backgroundColor: riskLevel.legend_color }} />
            <STTypo data-testid='risk-legend-component-level-type' type={typoType} color={riskLevel.text_color}>
              {t(getRiskLevelTranslationKey(riskLevel.type))}
            </STTypo>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegionalOverviewMapLegend;
